export const EventsList = [
  { date: "01-01-2023", name: "Nowy Rok" },
  { date: "01-06-2023", name: "Trzech Króli" },
  { date: "04-09-2023", name: "Wielkanoc" }, //ruchome
  { date: "04-10-2023", name: "Poniedziałek Wielkanocny" }, //ruchome
  { date: "05-01-2023", name: "Święto pracy" },
  { date: "05-03-2023", name: "Święto Konstytucji 3 Maja" },
  { date: "05-28-2023", name: "Zielone Świątki" }, //ruchome
  { date: "06-08-2023", name: "Boże Ciało" }, //ruchome
  { date: "07-15-2023", name: "Wniebowzięcie Najświętszej Maryi Panny" },
  { date: "11-01-2023", name: "Wszystkich Świętych" },
  { date: "11-11-2023", name: "Narodowe Święto Niepodległości" },
  { date: "12-25-2023", name: "Boże Narodzenie" },
  { date: "12-26-2023", name: "Drugi dzień Bożego Narodzenia" },

  { date: "01-01-2024", name: "Nowy Rok" },
  { date: "01-06-2024", name: "Trzech Króli" },
  { date: "03-31-2024", name: "Wielkanoc" }, //ruchome
  { date: "04-01-2024", name: "Poniedziałek Wielkanocny" }, //ruchome
  { date: "05-01-2024", name: "Święto pracy" },
  { date: "05-03-2024", name: "Święto Konstytucji 3 Maja" },
  { date: "05-19-2024", name: "Zielone Świątki" }, //ruchome
  { date: "05-30-2024", name: "Boże Ciało" }, //ruchome
  { date: "07-15-2024", name: "Wniebowzięcie Najświętszej Maryi Panny" },
  { date: "11-01-2024", name: "Wszystkich Świętych" },
  { date: "11-11-2024", name: "Narodowe Święto Niepodległości" },
  { date: "12-25-2024", name: "Boże Narodzenie" },
  { date: "12-26-2024", name: "Drugi dzień Bożego Narodzenia" },

  { date: "01-01-2025", name: "Nowy Rok" },
  { date: "01-06-2025", name: "Trzech Króli" },
  { date: "04-20-2025", name: "Wielkanoc" }, //ruchome
  { date: "04-21-2025", name: "Poniedziałek Wielkanocny" }, //ruchome
  { date: "05-01-2025", name: "Święto pracy" },
  { date: "05-03-2025", name: "Święto Konstytucji 3 Maja" },
  { date: "06-08-2025", name: "Zielone Świątki" }, //ruchome
  { date: "06-19-2025", name: "Boże Ciało" }, //ruchome
  { date: "07-15-2025", name: "Wniebowzięcie Najświętszej Maryi Panny" },
  { date: "11-01-2025", name: "Wszystkich Świętych" },
  { date: "11-11-2025", name: "Narodowe Święto Niepodległości" },
  { date: "12-25-2025", name: "Boże Narodzenie" },
  { date: "12-26-2025", name: "Drugi dzień Bożego Narodzenia" },

  { date: "01-01-2026", name: "Nowy Rok" },
  { date: "01-06-2026", name: "Trzech Króli" },
  { date: "04-05-2026", name: "Wielkanoc" }, //ruchome
  { date: "04-06-2026", name: "Poniedziałek Wielkanocny" }, //ruchome
  { date: "05-01-2026", name: "Święto pracy" },
  { date: "05-03-2026", name: "Święto Konstytucji 3 Maja" },
  { date: "05-24-2026", name: "Zielone Świątki" }, //ruchome
  { date: "06-04-2026", name: "Boże Ciało" }, //ruchome
  { date: "07-15-2026", name: "Wniebowzięcie Najświętszej Maryi Panny" },
  { date: "11-01-2026", name: "Wszystkich Świętych" },
  { date: "11-11-2026", name: "Narodowe Święto Niepodległości" },
  { date: "12-25-2026", name: "Boże Narodzenie" },
  { date: "12-26-2026", name: "Drugi dzień Bożego Narodzenia" },

  { date: "01-01-2027", name: "Nowy Rok" },
  { date: "01-06-2027", name: "Trzech Króli" },
  { date: "03-28-2027", name: "Wielkanoc" }, //ruchome
  { date: "03-29-2027", name: "Poniedziałek Wielkanocny" }, //ruchome
  { date: "05-01-2027", name: "Święto pracy" },
  { date: "05-03-2027", name: "Święto Konstytucji 3 Maja" },
  { date: "05-16-2027", name: "Zielone Świątki" }, //ruchome
  { date: "06-27-2027", name: "Boże Ciało" }, //ruchome
  { date: "07-15-2027", name: "Wniebowzięcie Najświętszej Maryi Panny" },
  { date: "11-01-2027", name: "Wszystkich Świętych" },
  { date: "11-11-2027", name: "Narodowe Święto Niepodległości" },
  { date: "12-25-2027", name: "Boże Narodzenie" },
  { date: "12-26-2027", name: "Drugi dzień Bożego Narodzenia" },
];
